import {create} from 'zustand'

interface MedicalReportTextAreaStore {
    // Modal state
    selectedField: string | null
    openModal: (selectedField: string) => void
    closeModal: () => void
    // Split view state
    isSplitView: boolean
    openSplitView: (selectedField: string) => void
    disableSplit: () => void
}

export const useMedicalReportTextAreaStore = create<MedicalReportTextAreaStore>(set => ({
    // Modal state
    selectedField: null,
    openModal: (selectedField: string) => set({selectedField}),
    closeModal: () =>
        set(() => ({
            selectedField: null,
            // Automatically disable split view when closing modal
            isSplitView: false
        })),
    // Split view state
    isSplitView: false,
    openSplitView: (selectedField: string) =>
        set(() => ({
            isSplitView: true,
            // Automatically open modal if it's not already open
            selectedField
        })),
    disableSplit: () => set({isSplitView: false})
}))
